// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetAsrHotWordsModelsQuery,
    BaseResponseListAsrHotWordsModelFoundResponse,
    PostAsrHotWordsModelsBody,
    BaseResponseAsrHotWordsModelFoundResponse,
} from '../types';

/**
 * 查询热词模型列表
 *
 * @export
 * @tags asr-hot-words-model-controller
 * @link [GET] /asrHotWordsModels
 */
export function getAsrHotWordsModels(): Promise<BaseResponseListAsrHotWordsModelFoundResponse>;
export function getAsrHotWordsModels(
    options: ApiOptions<never, GetAsrHotWordsModelsQuery>
): Promise<BaseResponseListAsrHotWordsModelFoundResponse>;
export function getAsrHotWordsModels(
    options?: ApiOptions<never, GetAsrHotWordsModelsQuery>
): Promise<BaseResponseListAsrHotWordsModelFoundResponse> {
    return request<never, never, GetAsrHotWordsModelsQuery>('/asrHotWordsModels', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAsrHotWordsModels',
    });
}

/**
 * 保存热词模型
 *
 * @export
 * @tags asr-hot-words-model-controller
 * @link [POST] /asrHotWordsModels
 */
export function postAsrHotWordsModels(
    data: PostAsrHotWordsModelsBody
): Promise<BaseResponseAsrHotWordsModelFoundResponse>;
export function postAsrHotWordsModels(
    data: PostAsrHotWordsModelsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseAsrHotWordsModelFoundResponse>;
export function postAsrHotWordsModels(
    data: PostAsrHotWordsModelsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseAsrHotWordsModelFoundResponse> {
    return request<PostAsrHotWordsModelsBody, never, never>('/asrHotWordsModels', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAsrHotWordsModels',
    });
}

export const meta = [
    { tags: ['asr-hot-words-model-controller'], path: '/asrHotWordsModels', method: 'get' },
    { tags: ['asr-hot-words-model-controller'], path: '/asrHotWordsModels', method: 'post' },
];
